import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFoodIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 19,
	viewBox: "0 0 18 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8571 15.3483C10.8571 16.6371 10.1196 17.6816 8.85714 17.6816H4.14286C2.88036 17.6816 2.14286 16.6371 2.14286 15.3483M11.3571 12.4316C11.9882 12.4316 12.5 13.0846 12.5 13.89C12.5 14.6953 11.9882 15.3483 11.3571 15.3483H1.64286C1.01179 15.3483 0.5 14.6953 0.5 13.89C0.5 13.0846 1.01179 12.4316 1.64286 12.4316",
			stroke: "currentColor",
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.67856 10.2218V10.2136C1.67856 8.188 3.33591 7.12804 5.36155 7.12804H8.01331C10.039 7.12804 11.6963 8.1961 11.6963 10.2218V10.2136M8.19746 4.18164L8.47147 6.53765M11.9909 12.4315H5.92542C5.84738 12.4316 5.77254 12.4626 5.71733 12.5177L4.72918 13.5059C4.7155 13.5196 4.69925 13.5304 4.68137 13.5379C4.66348 13.5453 4.64431 13.5491 4.62495 13.5491C4.60559 13.5491 4.58642 13.5453 4.56854 13.5379C4.55066 13.5304 4.53441 13.5196 4.52073 13.5059L3.53258 12.5177C3.47737 12.4626 3.40253 12.4316 3.32449 12.4315H1.38392C1.14949 12.4315 0.924661 12.3384 0.758894 12.1727C0.593127 12.0069 0.5 11.7821 0.5 11.5476C0.5 11.3132 0.593127 11.0884 0.758894 10.9226C0.924661 10.7568 1.14949 10.6637 1.38392 10.6637H11.9909C12.2254 10.6637 12.4502 10.7568 12.616 10.9226C12.7817 11.0884 12.8749 11.3132 12.8749 11.5476C12.8749 11.7821 12.7817 12.0069 12.616 12.1727C12.4502 12.3384 12.2254 12.4315 11.9909 12.4315Z",
			stroke: "currentColor",
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.75 17.6823H13.8808C14.1781 17.6823 14.4645 17.5699 14.6824 17.3677C14.9004 17.1654 15.0338 16.8883 15.056 16.5918L16.3738 4.12891",
			stroke: "currentColor",
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.875 4.12828L13.4643 1.77116L15.6071 0.5",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.57031 4.12891H16.9988",
			stroke: "currentColor",
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		})
	]
});
export default SvgFoodIcon;
